import { useRoute } from "@react-navigation/core";
import { NavigationProp, RouteProp } from "@react-navigation/native";
import React from "react";
import { View, useWindowDimensions } from "react-native";
import { FoodiOrderCheckout } from "../../../../web-components/orderCheckout";

interface IProps {
  navigation: NavigationProp<any>;
}

export const OrderCheckoutScreen: React.FC<IProps> = ({ navigation }) => {
  const route: RouteProp<
    { params: { offerId: string; holdingId?: string } },
    "params"
  > = useRoute();
  const offerId = route.params?.offerId ?? "";
  const holdingId = route.params?.holdingId;
  const { height } = useWindowDimensions();

  // Scroll via a plain overflow container bounded to the window height — NOT a
  // react-native-web ScrollView. RNW ScrollView bakes `transform: translateZ(0)`
  // into its scroll node, which becomes the containing block for `position:
  // fixed` descendants of the embedded MFE. A transform-free View keeps any
  // fixed overlay pinned to the viewport (same rationale as OfferDetailScreen).
  return (
    <View
      // @ts-ignore — web-only overflow value; RNW renders it as a scroll box.
      style={{ height, overflow: "scroll", backgroundColor: "#fff" }}
    >
      <FoodiOrderCheckout
        offerId={offerId}
        holdingId={holdingId}
        goBack={() => navigation.goBack()}
      />
    </View>
  );
};
